import { Users, Clock, Settings, Calendar } from "lucide-react";


export const getSteps = (translations) => [
    {
        title: translations('example.steps.step1.title'),
        description: translations('example.steps.step1.description'),
        icon: Users,
        example: translations('example.steps.step1.example')
    },
    {
        title: translations('example.steps.step2.title'),
        description: translations('example.steps.step2.description'),
        icon: Clock,
        example: translations('example.steps.step2.example')
    },
    {
        title: translations('example.steps.step3.title'),
        description: translations('example.steps.step3.description'),
        icon: Settings,
        example: translations('example.steps.step3.example')
    },
    {
        title: translations('example.steps.step4.title'), 
        description: translations('example.steps.step4.description'),
        icon: Calendar,
        example: translations('example.steps.step4.example')
    }

];

export const exampleEmployees = [
    {
        name: "John Smith",
        number: 101,
        wkl_Wrk_Load: 400,  
        day_WI: 80,         
        at_Roster_Num: 1
    },
    {
        name: "Sarah Johnson",
        number: 102,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Anna Brown",
        number: 103,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Dwyane Wade",
        number: 104,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Michael Porter",
        number: 105,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Kobe James",
        number: 106,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Larry Bird",
        number: 107,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Marvin Williams",
        number: 108,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Derrick Rose",
        number: 109,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    },
    {
        name: "Thomas Jones",
        number: 110,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
    }
];

export const exampleGeneralInfo = {
    week_or_days: 0,
    weeks: 4,
    days: 0,
    cycle: 0,
    offset: 0,
    GA: 0,
    OFFsum: 0
};

export const exampleSchedules = [
    {
        code: "FF",
        legend: "FF",
        description: "Off Day",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Off",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Off" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "HF",
        legend: "HF",
        description: "HF",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Off",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Off" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "XX",
        legend: "XX",
        description: "XX",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Off",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Off" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "YY",
        legend: "YY",
        description: "YY",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Off",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Off" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "FE",
        legend: "FE",
        description: "Vacation Day",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Vacation",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Vac" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "FR",
        legend: "FR",
        description: "Holiday",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Holiday",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Ho" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "Abs",
        legend: "Abs",
        description: "Absence",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Absence",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Abs" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "Cmp",
        legend: "Cmp",
        description: "Cmp",
        startDay: "Today",
        endDay: "Today",
        startTime: "",
        endTime: "",
        weightTime: 0,
        schedule_type: "Comp",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "Comp" },
            { active: false, type: '' },
            { active: false, type: '' },
            { active: false, type: '' }
        ]
    },
    {
        code: "T8",
        legend: "16-24",
        description: "Afternoon Shift",
        startDay: "Today",
        endDay: "Today",
        startTime: "16:00",
        endTime: "24:00",
        weightTime: "8",
        schedule_type: "W",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "T" },
            { active: false, type: "" },
            { active: false, type: "" },
            { active: false, type: "" }
        ]
    },
    {
        code: "N08",
        legend: "0-8",
        description: "Night Shift",
        startDay: "Today",
        endDay: "Today",
        startTime: "00:00",
        endTime: "08:00",
        weightTime: "8",
        schedule_type: "W",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "N" },
            { active: false, type: "" },
            { active: false, type: "" },
            { active: false, type: "" }
        ]
    },
    {
        code: "M08",
        legend: "8-16",
        description: "Morning Shift",
        startDay: "Today",
        endDay: "Today",
        startTime: "08:00",
        endTime: "16:00",
        weightTime: "8",
        schedule_type: "W",
        mealBreaks: [{
            enabled: false,
            startTime: "",
            endTime: ""
        }],
        shiftTypes: [
            { active: true, type: "M" },
            { active: false, type: "" },
            { active: false, type: "" },
            { active: false, type: "" }
        ]
    }
];

export const exampleShiftRestrictions = {
    "101": [
        {
            id: 1001,
            scheduleCode: "N8",  
            allowOnly: false  
        }
    ],
    "103": [  
        {
            id: 1002,
            scheduleCode: "M8",  
            allowOnly: true  
        }
    ]
};

export const exampleStaffRequirements = {
    max: ["10", "10", "10", "10", "10", "10", "10"],
    min: ["1", "1", "1", "1", "1", "1", "1"]
};

export const exampleStaffDistribution = {
    Monday: [
        {
            startTime: "480",  
            endTime: "540",   
            staff: "1"
        }
    ],
    Tuesday: [
        {
            startTime: "480",  
            endTime: "540",   
            staff: "1"
        }
    ],
    Wednesday: [
        {
            startTime: "480",  
            endTime: "540",   
            staff: "1"
        }
    ],
    Thursday: [
        {
            startTime: "480",  
            endTime: "540",  
            staff: "1"
        }
    ],
    Friday: [
        {
            startTime: "480",  
            endTime: "540",   
            staff: "1"
        }
    ],
    Saturday: [
        {
            startTime: "480",  
            endTime: "540",   
            staff: "1"
        }
    ],
    Sunday: [
        {
            startTime: "480",  
            endTime: "540",   
            staff: "1"
        }
    ],
    Holidays: [],
    "Eve of Holidays": []
};

export const exampleShiftSequence = [
    {
        shift: "FF",
        hard_min: "1",
        soft_min: "2",
        min_penalty: "0",
        soft_max: "2",
        hard_max: "3",
        max_penalty: "0"
    }
];

export const exampleWeeklySum = [
    {
        shift: "FF",
        hard_min: "1",
        soft_min: "2",
        min_penalty: "0",
        soft_max: "2",
        hard_max: "2",
        max_penalty: "0"
    }
];